import { render, staticRenderFns } from "./setUserMerchant.vue?vue&type=template&id=c0264774&"
import script from "./setUserMerchant.vue?vue&type=script&lang=js&"
export * from "./setUserMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0264774')) {
      api.createRecord('c0264774', component.options)
    } else {
      api.reload('c0264774', component.options)
    }
    module.hot.accept("./setUserMerchant.vue?vue&type=template&id=c0264774&", function () {
      api.rerender('c0264774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/setUserMerchant/setUserMerchant.vue"
export default component.exports